/**
 * Checkbox Widget for RUL Forms
 */

import { Checkbox } from 'antd';
import type { CheckboxWidget } from '@/api/types/rul.types';

interface CheckboxWidgetProps {
  widget: CheckboxWidget;
  onChange: (name: string, value: any) => void;
  error?: string;
}

export const CheckboxWidgetComponent: React.FC<CheckboxWidgetProps> = ({
  widget,
  onChange,
  error,
}) => {
  if (!widget.visible) return null;

  return (
    <div className="rul-field">
      <Checkbox
        checked={widget.value || false}
        disabled={!widget.enabled}
        onChange={(e) => onChange(widget.name, e.target.checked)}
      >
        {widget.label}
        {widget.required && <span className="rul-field-required">*</span>}
      </Checkbox>
      {widget.help_text && !error && (
        <div className="rul-field-help">{widget.help_text}</div>
      )}
      {error && <div className="rul-field-error">{error}</div>}
    </div>
  );
};
